import { createSelector } from 'reselect';

const selectBrandMappings = (state: any) => state.brandMappings;


export const selectBrandMappingsCurrentItem = createSelector([selectBrandMappings], (brandMappings) => brandMappings.current);

export const selectBrandMappingsListItems = createSelector([selectBrandMappings], (brandMappings) => brandMappings.list);

export const selectBrandMappingsItemById = (itemId: any) =>
    createSelector(selectBrandMappingsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectBrandMappingsQueryItems = createSelector([selectBrandMappings], (brandMappings) => brandMappings.query);

export const selectBrandMappingsCreatedItem = createSelector([selectBrandMappings], (brandMappings) => brandMappings.create);

export const selectBrandMappingsUpdatedItem = createSelector([selectBrandMappings], (brandMappings) => brandMappings.update);

export const selectBrandMappingsReadItem = createSelector([selectBrandMappings], (brandMappings) => brandMappings.read);

export const selectBrandMappingsDeletedItem = createSelector([selectBrandMappings], (brandMappings) => brandMappings.delete);

export const selectBrandMappingsSearchedItems = createSelector([selectBrandMappings], (brandMappings) => brandMappings.search);

export const selectBrandMappingsItemsCount = createSelector([selectBrandMappings], (brandMappings) => brandMappings.count);

export const selectBrandMappingsItemsFilter = createSelector([selectBrandMappings], (brandMappings) => brandMappings.filter);